import { CalendarOutlined, EnvironmentOutlined } from '@ant-design/icons'
import { Row } from 'antd'
import { CollectionProps } from 'app/components/Core/convention'
import GoogleMap from 'app/components/Modules/Map/Map'
import Button from 'app/components/UI-Elements/General/Button'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import { RecordType } from 'app/constants/GlobalTypes'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import { useState } from 'react'
import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import Drawer from './Drawer'
import LineItemImage from './Image'

const LineItemMap: React.FC<CollectionProps<ILineItem>> = ({ collection: lineItems }) => {
  const [selectedItems, setSelectedItems] = useState<ILineItem[]>([])
  const { tCore } = useTranslation({ scope: 'map', recordType: RecordType.line_item })
  const navigate = useNavigate()

  const sortedLineItems = React.useMemo(
    () => lineItems.sort((a, b) => (a.name > b.name ? 1 : -1)),
    [lineItems]
  )

  const onClick = (lineItem: ILineItem) => {
    navigate(Routes.Rental.member(lineItem.rental_id.toString()).machine_interaction)
  }

  const onSelect = (selectedItems: number[]) => {
    setSelectedItems(lineItems.filter((item: ILineItem) => selectedItems.includes(item.id)))
  }

  const tooltipRenderer = (item: ILineItem) => {
    return (
      <Row gutter={[0, 24]} className="mb-0">
        <KCol span={20}>
          <Row align="middle" gutter={[0, 12]}>
            <KCol span={24}>
              <h5 className="mb-0">{item.name}</h5>
            </KCol>
            <KCol span={24}>
              <span className="text-primary">{item.category_segment_name}</span>
            </KCol>
          </Row>
        </KCol>
        <KCol span={4} className="text-right">
          <LineItemImage member={item} />
        </KCol>
        <KCol span={24}>
          <div className="d-flex">
            <EnvironmentOutlined />
            <span className=" ml-2 text-primary">{item.location}</span>
          </div>
        </KCol>
        <KCol span={24} className="pb-0">
          <div className="d-flex justify-content-between">
            <div className="my-auto">
              <CalendarOutlined />
              <span className=" ml-2 text-primary">
                {tCore({ id: 'rented_until' })}:
                <strong className="font-weight-bold"> {item.return_date}</strong>
              </span>
            </div>
            <Button
              id="line-item-map-tooltip"
              type="primary"
              onClick={() => onClick(item)}
              title={tCore({ id: 'extend_rental' })}
            />
          </div>
        </KCol>
      </Row>
    )
  }

  return (
    <GoogleMap<ILineItem>
      collection={selectedItems.length ? selectedItems : lineItems}
      tooltip={tooltipRenderer}
      drawer={<Drawer props={{ onSelect, selectedItems }} collection={sortedLineItems} />}
    />
  )
}

export default LineItemMap
